<template>
  <v-card outlined class="app-card">
    <v-card-title class="app-card-title">Tramitações</v-card-title>
    <v-card-text class="app-card-content">
      <v-timeline :dense="true">
        <v-timeline-item
          v-for="item in data"
          :key="item.id"
          color="light-blue darken-4"
          small
          fill-dot
          icon="done"
        >
          <v-alert
            :value="true"
            dense
            border="left"
            color="light-blue darken-3"
            dark
            class="white--text"
          >
            <p>
              <strong>Data: </strong>
              {{ item.dataCadastro | date }}
            </p>
            <p>
              <strong>Setor Origem: </strong>
              {{ item.origemMensagem.nome }}
            </p>
            <p>
              <strong>Setor Destino: </strong>
              {{ item.destinoMensagem.nome }}
            </p>
            <p>
              <strong>Mensagem: </strong>
              {{ item.mensagem }}
            </p>
          </v-alert>
        </v-timeline-item>
      </v-timeline>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "Tramitacoes",
  props: { data: Array }
};
</script>

<style lang="scss" scoped>
p {
  margin-bottom: 0px;
  text-transform: uppercase;
  font-size: 13px !important;
}
</style>
